// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'

/* next 5 lines moved */
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css'

/* those two where before */
import App from './App'
import router from './router'



import { store } from './store.js'

Vue.config.productionTip = false

import VueAdsense from 'vue-adsense'
Vue.component('adsense', VueAdsense)

import { timer } from './components/Helper.vue'
Vue.component('timer', timer)

/* Meine Componenten */

// import One from './questions/one/One.vue'
// Vue.component('question-one', One)

// import OneEdit from './questions/one/One.Edit.vue'
// Vue.component('question-one-edit', OneEdit)

import { questionTypes } from './helper.js'
questionTypes.forEach( t => {
	Vue.component('question-' + t.id, require('./questions/' + t.id + '/' + t.Id + '.vue'))
	Vue.component('question-' + t.id + '-edit', require('./questions/' + t.id + '/' + t.Id + '.Edit.vue'))
})



/* mystuff olol */
Vue.prototype.nl2br = str => str ? str.replace(/\n/g, "<br />") : ''


/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	template: '<App/>',
	components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js